import { deleteApi, get, post } from "../GenericServices";

const SaleOrder = {
  getSaleOrders: (queryString) => {
    return get(`sale-order?${queryString}`);
  },
  getSaleOrdersDetail: (id) => {
    return get(`sale-order/${id}`);
  },
  saveSaleOrders: (data) => {
    return post(`sale-order`, data);
  },
  deleteSaleOrders: (id) => {
    return deleteApi(`sale-order/${id}`);
  },
};

export default SaleOrder;
